import { Loader } from 'kiswe-ui'
import { AssetType } from '../types/assets'
import type LayoutBox from '@/modules/layouts/classes/LayoutBox'

export class CasterCSS {
  color: string = '#FFFFFF'
  fontFamily?: string = '' // allow fallback when previewing
  fontSize: string = ''
  labelTop?: number = 0
  labelVisible: boolean = false
  muted: boolean = false

  constructor (data?: unknown) {
    if (data === undefined) return
    this.color = Loader.loadString(data, 'color', this.color)
    this.fontFamily = Loader.loadString(data, 'fontFamily', this.fontFamily)
    this.fontSize = Loader.loadString(data, 'fontSize', this.fontSize)
    this.labelTop = Loader.loadNumber(data, 'labelTop', this.labelTop)
    this.labelVisible = Loader.loadBoolean(data, 'labelVisible', this.labelVisible)
    this.muted = Loader.loadBoolean(data, 'muted', this.muted)
  }
}

export class ChatUserCSS {
  bg: string = '#000'
  text: string = '#fff'
}

export class ChatCSS {
  general: {
    font: string,
    fontsize: number
  } = {
    font: 'Helvetica',
    fontsize: 6
  }
  user1: ChatUserCSS = new ChatUserCSS()
  user2: ChatUserCSS = new ChatUserCSS()
  user3: ChatUserCSS = new ChatUserCSS()
  user4: ChatUserCSS = new ChatUserCSS()

  constructor (data?: unknown) {
    if (data === undefined) return
    this.general = Loader.loadAndCast(data, 'general', this.general)
  }
}

export class SimplecgCSS {
  background: {
    borderradius: number,
    color: string|null
  } = {
    borderradius: 3,
    color: null
  }
  text: {
    color: string,
    font: string,
    fontsize: number,
    left: number,
    ltr: boolean,
    top: number,
    width: number
  } = {
    color: 'rgba(255,255,255,1)',
    font: 'Noto Sans',
    fontsize: 16,
    left: 10,
    top: 40,
    ltr: true,
    width: 80
  }
}

export enum BoxGroupType {
  Front = 'front',
  Caster = 'caster',
  Back = 'back'
}

export enum DemoSize {
  Small = 'small',
  Large = 'large',
  Poll = 'poll'
}

export class LiveChatCSS {
  background: {
    borderradius?: number,
    color?: string,
  } = {}
  username: {
    color?: string,
    left?: number,
    top?: number,
    font?: string,
    fontsize?: number
  } = {}
  text: {
    color?: string,
    font?: string,
    fontsize?: number,
    padding?: number,
    left?: number,
    top?: number,
    visible?: boolean
  } = {}

  constructor (data?: unknown) {
    if (data === undefined) return
    this.background = Loader.loadAndCast(data, 'background', this.background)
    this.username = Loader.loadAndCast(data, 'username', this.username)
    this.text = Loader.loadAndCast(data, 'text', this.text)
  }
}

export interface SceneTransition {
  type: TransitionType,
  duration?: number,
  actions: SceneTransitionAction[]
}

export interface SceneTransitionAction {
  type: string,
  method: string,
  url: string,
  body: string,
  token: string,
  offsetDelay: number
}

export interface LayoutBoxMap {
  [boxid: string]: LayoutBox
}

export enum LayoutBoxField {
  FRONT = 'front',
  BACK = 'back',
  CASTER = 'caster',
  TRANSITION = 'transition'
}

export enum LayoutBoxType {
  BOX = 'box',
  CONTAINER = 'container'
}

export enum BackdropMode {
  Blur = 'Blur',
  None = 'None',
  ContentBlur = 'ContentBlur'
}

export enum ContentAlignment {
  START = 'flex-start',
  CENTER = 'center',
  END = 'flex-end'
}

export enum TransitionType {
  NONE = 'cut',
  TRANSLATE = 'translate',
  VIDEO = 'video'
}

export enum HttpRequestMethod {
  GET = 'get',
  PUT = 'put',
  POST = 'post',
  DELETE = 'delete'
}

export const isAssetTypeVideoOrText = (types: AssetType[]|undefined) => {
  return types && [AssetType.SimpleCG, AssetType.Video].includes(types[0])
}

export enum LayoutBoxOptionType {
  BOOLEAN = 'boolean',
  COLOR = 'color',
  FONT = 'font',
  NUMBER = 'number',
}

export interface LayoutBoxOption {
  name: string,
  title?: string,
  type: LayoutBoxOptionType,
  value: any,
  min?: number,
  max?: number,
}

export enum LayoutPreviewMode {
  BoxFields = 'fields',
  StreamsOnly = 'streams'
}

export const LAYOUT_BOX_Z_INDEX: number = 1
